import React, { useEffect, useState } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import axios from 'axios'; // Import Axios
import "../../style/videos.css";

function Videos() {

  const [aboutUsVideo, setAboutUsVideos] = useState("");
  const [publishWithUsVideo, setPublishVideos] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get("https://paulinesafrica.org/api/v1/sitemanagement/videos/");
        const videosData = response.data; 
      
        const aboutVideo = videosData.find(
          (video) =>
            video.page.name.trim() === "Home" && video.purpose.trim() === "About Us Video"
        );
        setAboutUsVideos(aboutVideo);

        const publishVideo = videosData.find(
          (video) =>
            video.page.name.trim() === "Home" &&
            video.purpose.trim() === "Publish with Us Video"
        );
        setPublishVideos(publishVideo);
      
      } catch (error) {
        console.error("Error fetching videos:", error);
        
      }
    };

    fetchVideos();
  }, []);

  return (
    <Container className="video-container">
      <Row className="videos gx-3">
        <Col xs={12} md={6} className="mb-3  p-0">
          <Card className="rounded-video p-0 card-border">
            <iframe
              width="100%"
              height="350"
              src={aboutUsVideo?.video_url}
              title="YouTube video player"
            
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              className="rounded-video"
            ></iframe>
          </Card>
        </Col>
        <Col xs={12} md={6} className="video-content mb-3 video-description card-border">
          <Card
            className="text-center border-0 "
            style={{ backgroundColor: "transparent" }}
          >
            The Daughters of St Paul, an international religious congregation
            using the communications media to spread the Gospel message and to
            promote the dignity of all people.
          </Card>
        </Col>
      </Row>

      <Row className="videos gx-3 flex-xs-column-reverse">
        <Col xs={12} md={6} className="mb-3">
          <Card className="rounded-video p-0 p-0 card-border">
            <iframe
              width="100%"
              height="350"
              src={publishWithUsVideo?.video_url}
              title="YouTube video player"
            
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
             referrerPolicy="strict-origin-when-cross-origin"
              className="rounded-video"
            ></iframe>
          </Card>
        </Col>

        <Col xs={12} md={6} className="video-content mb-3 video-description card-border">
          <Card
            className="text-center p-0 border-0"
            style={{ backgroundColor: "transparent" }}
          >
            Paulines books and audiovisuals Africa is an activity of the
            Daughters of St Paul, an international religious congregation using
            the communications media to spread the Gospel message and to promote
            the dignity of all people.
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Videos;
